import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Api from "../../Classes/API/UsersApi";
import SearchAccountingSessions from "../../Classes/Models/Requests/Accounting/SearchAccountingSession";
import DeleteAccountingEntry from "Classes/Models/Requests/Accounting/DeleteAccountingEntry";
import SearchUserModel from "../../Classes/Models/Requests/Users/SearchUser";
import SearchTherapistTypes from "../../Classes/Models/Requests/Administration/Therapists/SearchTherapistTypes";
import SearchAccountingTherapistHourId from "../../Classes/Models/Requests/Accounting/SearchAccountingTherapistHourId";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import SearchAccountingEntry from "../../Classes/Models/Requests/Accounting/SearchAccountingEntry";
import { useNavigate } from "react-router-dom";
const AccountingEntryList = () => {
  const [AccountingSessions, SetAccountingSessions] = useState([]);
  const [AccountingEntries, SetAccountingEntries] = useState([]);

  const navigate = useNavigate();
  function handleOnClick(url) {
    navigate(url, { replace: true }), [navigate];
  }

  let SearchModel = SearchAccountingEntry;
  let Users = [];
  let TherapistTypes = [];
  let accountingTherapistHourIds = [];

  const [title, SetTitle] = useState("");
  const [amount, SetAmount] = useState(0);
  const [description, SetDescription] = useState("");
  const [category, SetCategory] = useState("");
  const [entryType, SetEntryType] = useState("");
  const [accountingSessionId, SetaccountingSessionId] = useState(0);
  const [isProfit, SetisProfit] = useState(false);
  const [patientId, SetpatientId] = useState(0);
  const [therapistId, SettherapistId] = useState(0);
  const [accountingTherapistHourId, SetaccountingTherapistHourId] = useState(0);

  function SearchUsers(req) {
    Api.SearchUsers(req).then((res) => {
      Users = res.data.list;
    });
  }

  async function deleteRecord(id) {
    let deleteModel = DeleteAccountingEntry;
    deleteModel.id = id;
    Api.DeleteAccountingEntries(deleteModel).then((res) => {
      if ((res.data = "Success")) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Record Deleted",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  }

  function SearchTherapistTypesFun(req) {
    Api.SearchTherapistTypes(req).then((res) => {
      TherapistTypes.push(...res.data.list);
      console.log(TherapistTypes);
    });
  }

  function SearchaccountingTherapistHourIdFun(req) {
    Api.accountingTherapistHourId(req).then((res) => {
      accountingTherapistHourIds = res.data.list;
      console.log(accountingTherapistHourIds);
    });
  }

  useEffect(() => {
    let req = SearchAccountingSessions;
    Api.SearchAccountingSession(req).then((res) => {
      SetAccountingSessions(res.data.list);
    });

    let users = SearchUserModel;
    users.userType = "Patient";
    SearchUsers(users);

    let therapistTypes = SearchTherapistTypes;
    SearchTherapistTypesFun(therapistTypes);

    Api.SearchAccountingEntries(SearchModel).then((res) => {
      SetAccountingEntries(res.data.list);
    });
  }, ["default"]);

  useEffect(() => {
    let accountingTherapistHourIds = SearchAccountingTherapistHourId;
    accountingTherapistHourIds.therapistId = therapistId;
    SearchaccountingTherapistHourIdFun(accountingTherapistHourIds);
  }, [therapistId]);

  function startSearch() {
    SearchModel.id = localStorage.getItem("userId");
    SearchModel.title = title;
    SearchModel.amount = amount;
    SearchModel.description = description;
    SearchModel.category = category;
    SearchModel.entryType = entryType;
    SearchModel.accountingSessionId = accountingSessionId;
    SearchModel.isProfit = isProfit;
    SearchModel.patientId = patientId;
    SearchModel.therapistId = therapistId;
    SearchModel.timeStamp = timeStamp;
    SearchModel.employeeId = employeeId;
    SearchModel.facilityId = facilityId;
    SearchModel.accountingTherapistHourId = accountingTherapistHourId;

    Api.SearchAccountingEntries(SearchModel).then((res) => {
      SetAccountingEntries(res.data.list);
    });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <div className="row">
          <div className="container">
            <div className="card">
              <div className="card-header">search accounting Entries</div>
              <div className="card-body">
                <div className="card-body">
                  <div className="row">
                    <div className="container">
                      {/* title */}
                      <div className="input-group input-group-md">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="title"
                          aria-describedby="sizing-addon1"
                          onChange={(e) => SetTitle(e.target.value)}
                        />
                      </div>

                      {/* amount */}
                      <div className="input-group input-group-md">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="amount"
                          aria-describedby="sizing-addon1"
                          onChange={(e) => SetAmount(e.target.value)}
                        />
                      </div>

                      {/* description */}
                      <div className="input-group input-group-md">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="description"
                          aria-describedby="sizing-addon1"
                          onChange={(e) => SetDescription(e.target.value)}
                        />
                      </div>

                      {/* category */}
                      <div className="input-group input-group-md">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="category"
                          aria-describedby="sizing-addon1"
                          onChange={(e) => SetCategory(e.target.value)}
                        />
                      </div>

                      {/* entryType */}
                      <div className="input-group input-group-md">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="entryType"
                          aria-describedby="sizing-addon1"
                          onChange={(e) => SetEntryType(e.target.value)}
                        />
                      </div>

                      {/* isProfit */}
                      <div className="input-group-text">
                        <input
                          type="checkbox"
                          aria-label="Checkbox for following text input"
                          onChange={(e) => SetisProfit(e.target.value)}
                        />
                      </div>

                      {/* patientId */}
                      <select
                        className="custom-select"
                        onChange={(e) => SetpatientId(e.target.value)}
                      >
                        {Users.map((user) => (
                          <option value={user.id}>
                            {user.firstName} {user.lastName}
                          </option>
                        ))}
                      </select>

                      {/* accountingSessionId */}
                      <select
                        className="custom-select"
                        onChange={(e) => SetaccountingSessionId(e.target.value)}
                      >
                        {AccountingSessions.map((accountingSession) => (
                          <option value={accountingSession.id}>{accountingSession.title}</option>
                        ))}
                      </select>

                      {/* therapistId */}
                      <select
                        className="custom-select"
                        onChange={(e) => SettherapistId(e.target.value)}
                      >
                        {TherapistTypes.map((therapistType) => (
                          <option value={therapistType.id}>{therapistType.typeName}</option>
                        ))}
                      </select>

                      {/* accountingTherapistHourId */}
                      <select
                        className="custom-select"
                        onChange={(e) => SetaccountingTherapistHourId(e.target.value)}
                      >
                        {accountingTherapistHourIds.map((accountingTherapistHourId) => (
                          <option value={accountingTherapistHourId.id}>
                            {accountingTherapistHourId.id}
                          </option>
                        ))}
                      </select>

                      <button
                        type="button"
                        className="btn btn-primary mt-2 float-right"
                        onClick={startSearch}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="container">
            <div className="card">
              <div className="card=header">Accounting Entry List</div>
              <table className="table table-sm table-bordered text-center">
                <thead>
                  <tr>
                    <th scope="col">id</th>
                    <th scope="col">Standard Hourly Rate</th>
                    <th scope="col">typeName</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {AccountingEntries.map((item) => {
                    return (
                      <tr key={Math.random()}>
                        <td>{item.id}</td>
                        <td>{item.standardHourlyRate}</td>
                        <td>{item.typeName}</td>
                        <td>
                          <button
                            className="btn btn-danger btn-sm mx-2"
                            onClick={deleteRecord.bind(this, item.id)}
                          >
                            Delete
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={handleOnClick.bind(this, "/editAccountingEntry/" + item.id)}
                          >
                            Edit
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </MDBox>
    </DashboardLayout>
  );
};

export default AccountingEntryList;
